var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.034,
    height: 33.034,
    viewBox: "0 0 33.034 33.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(460 -3168.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M0,33.034H33.034V0H0Z",
    transform: "translate(-460 3168.285)",
    fill: "#c80000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(-457.812 3181.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M32.808,5.322H31.051a.109.109,0,0,0-.091.048,1.834,1.834,0,0,1-1.615.982,2.015,2.015,0,0,1-1.938-2.131,1.987,1.987,0,0,1,1.929-2.092,1.82,1.82,0,0,1,1.63,1.007l.011.02a.111.111,0,0,0,.091.047h1.76a.108.108,0,0,0,.108-.108.11.11,0,0,0,0-.027l0-.015a3.726,3.726,0,1,0-.02,2.421l0-.009a.105.105,0,0,0,.006-.034.109.109,0,0,0-.108-.108",
    transform: "translate(-18.56 -0.522)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M60.492,5.322H58.735a.109.109,0,0,0-.091.048,1.834,1.834,0,0,1-1.615.982,2.015,2.015,0,0,1-1.938-2.131A1.987,1.987,0,0,1,57.02,2.129a1.82,1.82,0,0,1,1.63,1.007l.011.02a.11.11,0,0,0,.09.047h1.76a.108.108,0,0,0,.108-.108.089.089,0,0,0,0-.027l0-.015a3.726,3.726,0,1,0-.02,2.421.054.054,0,0,0,0-.009.106.106,0,0,0,.006-.034.109.109,0,0,0-.108-.108",
    transform: "translate(-38.427 -0.522)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M5.048,5.6l0-.013L4.381,3.379a.067.067,0,0,0-.065-.049.063.063,0,0,0-.062.047L3.587,5.594l0,.009a.048.048,0,0,0,0,.013.064.064,0,0,0,.064.064H4.985a.064.064,0,0,0,.065-.064A.086.086,0,0,0,5.048,5.6ZM5.581,7.2a.109.109,0,0,0-.1-.067H3.132a.11.11,0,0,0-.1.067L2.7,8.1h0a.107.107,0,0,1-.1.066H.859A.108.108,0,0,1,.75,8.06a.1.1,0,0,1,.008-.039l0,0,2.8-6.944,0-.008A.109.109,0,0,1,3.665,1H4.97a.108.108,0,0,1,.1.061l.006.014L7.844,8.013l.006.014a.1.1,0,0,1,.006.033.108.108,0,0,1-.108.108H5.988a.109.109,0,0,1-.1-.065v0Z",
    transform: "translate(-0.75 -0.866)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M83.48,5.6l0-.013-.663-2.212a.067.067,0,0,0-.065-.049.063.063,0,0,0-.062.047l-.667,2.217,0,.009a.048.048,0,0,0,0,.013.064.064,0,0,0,.064.064h1.338a.063.063,0,0,0,.064-.064A.086.086,0,0,0,83.48,5.6ZM84.013,7.2a.109.109,0,0,0-.1-.067H81.563a.11.11,0,0,0-.1.067l-.331.9h0a.108.108,0,0,1-.1.066H79.291a.108.108,0,0,1-.109-.108.1.1,0,0,1,.008-.039l0,0,2.8-6.944,0-.008A.109.109,0,0,1,82.1,1H83.4a.108.108,0,0,1,.1.061l.006.014,2.772,6.937.005.014a.1.1,0,0,1,.006.033.108.108,0,0,1-.108.108h-1.76a.108.108,0,0,1-.1-.065v0Z",
    transform: "translate(-57.037 -0.866)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotLogo);
export default __webpack_public_path__ + "static/media/chatbot_logo.d743e9a77e6468b23be6dd5ff599d0b1.svg";
export { ForwardRef as ReactComponent };